/*
 * @Author: xuhongwei
 * @Date: 2021-03-05 21:41:07
 * @LastEditors: xuhongwei
 * @LastEditTime: 2021-03-13 14:14:43
 */
/**
 * vue directives
 */
import Vue from "vue";

/**
 * 长按事件
 * 使用v-longpress方法绑定，例如：<div v-longpress="handleLongpress"></div>
 */
// Vue.directive("longpress", {
//   bind: (el: any, binding: any) => {
//     if (typeof binding.value !== "function") {
//       throw new Error("v-longpress must be a function");
//     }
//     let currentTime = 0;
//     function touchstart() {
//       currentTime = new Date().getTime();
//     }
//     function touchend() {
//       const currentEndTime = new Date().getTime();
//       if (currentEndTime - currentTime > 600) {
//         binding.value();
//       }
//     }
//     function touchmove() {
//       currentTime = new Date().getTime();
//     }
//     el.addEventListener("touchstart", touchstart, false);
//     el.addEventListener("touchmove", touchmove, false);
//     el.addEventListener("touchend", touchend, false);
//     el.addEventListener("touchcancel", touchend, false);
//   }
// });
Vue.directive("longpress", {
  bind: function (el: any, binding: any, vNode: any) {
    // 确保提供的表达式是函数
    if (typeof binding.value !== "function") {
      // 获取组件名称
      const compName = vNode.context.name;
      // 将警告传递给控制台
      let warn = `[longpress:] provided expression '${binding.expression}' is not a function, but has to be `;
      if (compName) {
        warn += `Found in component '${compName}' `;
      }

      console.warn(warn);
    }

    // 定义变量
    let pressTimer: any = null;

    // 取消计时器
    let cancel = (e: any) => {
      // 检查计时器是否有值
      if (pressTimer !== null) {
        clearTimeout(pressTimer);
        pressTimer = null;
      }
    };

    // 运行函数
    let handler = (e: any) => {
      // 执行传递给指令的方法
      binding.value(e);
    };

    // 定义函数处理程序
    // 创建计时器（ 1秒后执行函数 ）
    let start = (e: any) => {
      if (e.type === "click" && e.button !== 0) {
        return;
      }

      if (pressTimer === null) {
        pressTimer = setTimeout(() => {
          // 执行函数
          handler(e);
        }, 500);
      }
    };

    // 添加事件监听器
    el.addEventListener("mousedown", start);
    el.addEventListener("touchstart", start);

    // 取消计时器
    el.addEventListener("click", cancel);
    el.addEventListener("mouseout", cancel);
    el.addEventListener("touchend", cancel);
    el.addEventListener("touchcancel", cancel);
  }
});
